import { defineStore } from 'pinia'
import { ref } from 'vue'

interface RootState {
  summary: string
  detail: string
  severity: 'error' | 'success' | 'info'
  index?: number
  life?: number
  position?:
    | 'top-right'
    | 'top-left'
    | 'top-center'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right'
    | 'center'
}
export const useToastStore = defineStore('toastStore', () => {
  const toastData = ref<RootState>({
    detail: '',
    summary: '',
    severity: 'success',
    index: 0,
    life: 6000,
    position: 'top-right'
  })

  function updateToastState({ severity, summary, detail, life, position }: RootState) {
    toastData.value = {
      summary,
      severity,
      detail,
      life: life ?? 6000,
      index: toastData.value.index ? (toastData.value.index += 1) : 0,
      position: position ?? 'top-right'
    }
  }

  return {
    updateToastState,
    toastData
  }
})
